import { graphql, HttpResponse } from 'msw'
import { type EnrollmentFixedIncomeData, type EnrollmentFixedIncomeSubmitOutput } from '../../../models'
import { FixedIncomeCategory, InvestmentRiskToleranceCategory } from '../../../models/enrollment/enrollment'

export const getEnrollmentFixedIncomeDataMock: EnrollmentFixedIncomeData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/fixed-income',
  enrollmentData: {
    experimentId: 'BARBECUE',
    recommendation: {
      investment: {
        fixedIncomeCategory: [
          {
            type: FixedIncomeCategory.GovernmentBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 18,
              allowedMinPercent: 8,
              allowedMaxPercent: 28,
            },
          },
          {
            type: FixedIncomeCategory.HighYieldBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 21,
              allowedMinPercent: 11,
              allowedMaxPercent: 31,
            },
          },
          {
            type: FixedIncomeCategory.CorporateBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 20,
              allowedMinPercent: 10,
              allowedMaxPercent: 30,
            },
          },
          {
            type: FixedIncomeCategory.MunicipalBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 19,
              allowedMinPercent: 9,
              allowedMaxPercent: 29,
            },
          },
          {
            type: FixedIncomeCategory.InternationalBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 22,
              allowedMinPercent: 12,
              allowedMaxPercent: 32,
            },
          },
        ],
      },
    },
    userInfo: {
      investment: {
        riskTolerance: {
          type: InvestmentRiskToleranceCategory.Balanced_4,
          allocation: {
            equityPercent: 67,
            fixedIncomePercent: 29.5,
            cashEquivalentPercent: 3.5,
          },
        },
      },
    },
  },
}

export const submitEnrollmentFixedIncomeDataMock: EnrollmentFixedIncomeSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/cash-equivalent',
  enrollmentData: {
    experimentId: 'BARBECUE',
    recommendation: {
      investment: {
        fixedIncomeCategory: [
          {
            type: FixedIncomeCategory.GovernmentBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 18,
              allowedMinPercent: 8,
              allowedMaxPercent: 28,
            },
          },
          {
            type: FixedIncomeCategory.HighYieldBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 21,
              allowedMinPercent: 11,
              allowedMaxPercent: 31,
            },
          },
          {
            type: FixedIncomeCategory.CorporateBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 20,
              allowedMinPercent: 10,
              allowedMaxPercent: 30,
            },
          },
          {
            type: FixedIncomeCategory.MunicipalBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 19,
              allowedMinPercent: 9,
              allowedMaxPercent: 29,
            },
          },
          {
            type: FixedIncomeCategory.InternationalBonds,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 22,
              allowedMinPercent: 12,
              allowedMaxPercent: 32,
            },
          },
        ],
      },
    },
    userInfo: {
      investment: {
        riskTolerance: {
          type: InvestmentRiskToleranceCategory.Balanced_4,
          allocation: {
            equityPercent: 67,
            fixedIncomePercent: 29.5,
            cashEquivalentPercent: 3.5,
          },
        },
      },
    },
  },
}

export const mockGetEnrollmentFixedIncomeData = graphql.mutation('getEnrollmentFixedIncomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentFixedIncomeDataMock } })
})

export const mockSubmitEnrollmentFixedIncomeData = graphql.mutation('submitEnrollmentFixedIncomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentFixedIncomeDataMock } })
})

export const mockEnrollmentFixedIncome = [mockGetEnrollmentFixedIncomeData, mockSubmitEnrollmentFixedIncomeData]
